<div class="info-panel"
     [style.top]="model.top" [style.right]="model.right"
     [style.min-height.px]="model.minHeight? model.minHeight:100">
    <div class="header" *ngIf="model.title">
        <div class="title">
            {{model.title}}
        </div>
        <bd-fa-button [name]="'times'" *ngIf="model.showCloseBtn" (click)="onCloseBtnClicked()"></bd-fa-button>
    </div>
    <div class="message-container" >
            <div *ngFor="let row of model.msgRows; let isLast = last" class="price-row" [ngClass]="{'last':isLast}">
                {{row}}
            </div>
    </div>
</div>
